import { render } from "./app-modal-copy-business.vue?vue&type=template&id=6e2465ff"
import script from "./app-modal-copy-business.vue?vue&type=script&lang=js"
export * from "./app-modal-copy-business.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-copy-business.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e2465ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e2465ff', __exports__)) {
    console.log('reload')
    api.reload('6e2465ff', __exports__)
  }
  
  module.hot.accept("./app-modal-copy-business.vue?vue&type=template&id=6e2465ff", () => {
    console.log('re-render')
    api.rerender('6e2465ff', render)
  })

}


export default __exports__